<template>
  <div class="historyWork clear">
    <!-- <div class="timeBox">
          <p>{{content.publishDate | timeAxis(content.currentTime)}}</p>
        </div> -->
    <div class="historyHead">
      <div class="headContent clear">
        <span>{{content.workName}}</span>
      </div>
      <div class="workName">
        <img src="../../../static/new icon/workName.png" alt="" @mouseenter="enter" @mouseleave="leave">
        <!-- <span v-show="content.serviceType != 0">{{content.bookName}}</span> -->
        <span class="down" v-show="showName">{{content.bookName}}</span>
      </div>
      <div class="titleAndState">
        <div class="state" :class="{underway: content.state == 0,unpublished:content.state == 1,end:content.state == -1}">
          <i class="point" :class="{underway: content.state == 0,unpublished:content.state == 1,end:content.state == -1}"></i>
          {{Timetext[content.state+1]}}
        </div>

        <div class="publishTime">
          <span v-if="content.state == 0">{{content.publishDate | formatDate('yyyy-MM-dd W hh:mm')}} 发布</span>
          <span v-if="content.state == -1">{{content.effectiveDate | formatDate('yyyy-MM-dd W hh:mm')}} 截止</span>
          {{content.stateText}}
        </div>
      </div>
    </div>
    <div>
      <div class="historyContent" v-for="(item, index) in content.workList" :key="item.id">
        <div class="receiveObj">
          <div>
            <p :title="item.reviceObject">{{item.reviceObject}}</p>
          </div>
          <div class="summary" @click="toRank(item,-1,index)" v-if="content.state == 0 || content.state == -1">
            成绩汇总
          </div>
          <div class="recall_btn" @click="recall(item,index)">
            <span>撤回</span>
          </div>

          <div class="rush_btn" @click="rush(item,index)" v-if="content.state == 0 || content.state == -1">
            <span>催交</span>
            <!-- <span v-if="item.rush_state === 1">催交</span>
            <span v-else-if="item.rush_state === 2">
              <img src="./../../assets/img/loading_work.gif" alt="" style="vertical-align: text-top;" />
            </span>
            <span v-else>
              <span v-if="!item.rush_result" style="color: #ec2828;">催交失败</span>
              <span v-else><img src="./../../assets/img/success_work.png" alt="" style="vertical-align: text-top;" /></span>
            </span> -->
          </div>

        </div>
        <div>
          <div class="workContent clear" v-for="(item2, index2) in item.workContents" @click="toRank(item,index2,index)" :key="index2">
            <span>{{item2.resourceName}}</span>
            <span>
              <i style="color: #FF5400;">{{item2.submitCount}}</i>/&nbsp;&nbsp;{{item.totalNum}}人&nbsp;
              <i>完成</i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <notice :params="params1" :isNotice="isNotice1" @isConfirm="isConfirm1"></notice>
    <notice :params="params2" :isNotice="isNotice2" @isConfirm="isConfirm2"></notice>
  </div>
</template>

<script>
import fetch from "./../../fetch";
import notice from "./../../components/notice/notice.vue";
import selecter from "./../../components/selecter/selecter.vue";
import progressBar from "./../../components/progressBar/progressBar.vue";
import { timeAxis } from "./../../filter";
import { clientId, brandId, http } from "./../../config";

export default {
  data() {
    return {
      showName: false,
      TimeStatus: 2,
      timeStamp: "",
      timeStampText: "",
      Timetext: ["已截止", "进行中", "待发布"],
      d: "",
      h: "",
      m: "",
      isNotice1: false,
      params1: {},
      isNotice2: false,
      params2: {},
      operationText: "操作",
      operations: [{ name: "一键催交" }, { name: "撤回作业" }],
      index: "", //用户点击操作的对应的下标
      option_text: ["一键催交", "成绩汇总", "撤回作业"],
      remindType: 0
    };
  },
  components: {
    notice,
    selecter,
    progressBar
  },
  props: ["content", "delIndex", "PageIndex"],
  created() {
    this.$nextTick(() => {});
  },

  methods: {
    enter() {
      this.showName = true;
    },
    leave() {
      this.showName = false;
    },
    isConfirm1(val) {
      if (val) {
        let userId = JSON.parse(window.localStorage.user).userId.toString();
        let contents = this.content.workList[this.index];
        fetch
          .urgeWorks({
            workId: contents.workId,
            userId: userId
          })
          .then(res => {
            if (!res) {
              return false;
            }
            this.$toast("催交作业成功", "right");
          });
      }
    },
    isConfirm2(val) {
      if (val) {
        let contents = this.content.workList[this.index];
        fetch.delWork({ workId: contents.workId }).then(res => {
          if (!res) {
            return false;
          }
          this.$emit("removeWork", this.index, this.delIndex);
          this.$toast("撤回作业成功", "right");
        });
      }
    },
    toRank(item,index) {
      if (
        item.resourceType &&
        (item.resourceType == "803ef46d-e0cc-4f97-b1eb-b3ef411d058e" ||
          item.resourceType == "eb5d05a2-d604-4879-8f9a-be5a45ae414e")
      ) {
        return false;
      }
      console.log(item, "777")
      
      let params = {
        workId: item.workId,
        effectiveDate: this.content.effectiveDate, // 截止时间
        sendDate: this.content.sendDate, // 布置时间(定时发布)
        publishDate: this.content.publishDate, // 布置时间(立即发布)
        index: index, // 索引
        state: this.content.state, // 1为定时发布 0为立即发布
        bookName: this.content.bookName, // 书名
        workMessage: item.workMessage, // 备注信息
        reviceObject: item.reviceObject, // 班级
      };
      this.$router.push({
        path: "rankWork",
        query: params
      });
    },
    // 催交作业
    rush(item, index) {
      this.index = index;
      this.isNotice1 = !this.isNotice1;
      
      this.params1 = {
        type: 1,
        noticeText: "确定给未交作业的学生发提醒消息？",
        noticeTitle: "催交作业"
      };
    },
    // 撤回作业
    recall(item, index) {
      this.index = index;

      this.isNotice2 = !this.isNotice2;

      this.params2 = {
        type: 1,
        noticeText: "确定要撤回本次作业？",
        noticeTitle: "撤回作业"
      };
    },
    isClickBtn(item, index) {
      item.isShow_recall = !item.isShow_recall;
    }
  }
};
</script>



// WEBPACK FOOTER //
// history.vue?5e35a8fe